import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { store } from '../store'
import { LANG_EN, LANG_JP } from '../constants'
import { translation as translationEN } from './en'
import { translation as translationJP } from './ja'
import { updateLang } from '../actions/language'

i18next.getLang = () => {
    let localStorageLang
    try {
        localStorageLang = JSON.parse(JSON.parse(window.localStorage.getItem('persist:root'))?.language)
    } catch (e) {}
    return store.getState()?.language || localStorageLang || LANG_EN
}

i18next.setLang = (lang) => {
    i18next.changeLanguage(lang)
    store.dispatch(updateLang(lang))
}

i18next
    .use(initReactI18next) // bind react-i18next to the instance
    .init({
        resources: {
            [LANG_EN]: {
                translation: translationEN
            },
            [LANG_JP]: {
                translation: translationJP
            }
        },
        lng: LANG_EN,
        fallbackLng: LANG_JP,
        interpolation: {
            escapeValue: false // not needed for React as it escapes by default
        }
    })

export { i18next }
